import { render, staticRenderFns } from "./storesTableAuthorization.vue?vue&type=template&id=75bd54e1&scoped=true&"
import script from "./storesTableAuthorization.vue?vue&type=script&lang=js&"
export * from "./storesTableAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./storesTableAuthorization.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./storesTableAuthorization.vue?vue&type=style&index=1&id=75bd54e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bd54e1",
  null
  
)

component.options.__file = "storesTableAuthorization.vue"
export default component.exports